// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1qe0D","title":"ClientInsurance_title__3i9Nt","itemText":"ClientInsurance_itemText__1zSNg"};